import script from "./AiModelFields.vue?vue&type=script&setup=true&lang=js"
export * from "./AiModelFields.vue?vue&type=script&setup=true&lang=js"

import "./AiModelFields.vue?vue&type=style&index=0&id=72db2f87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72db2f87"]])

export default __exports__